export default { sha: '5282a1ae03b47932dace7b1442945dda0ca0f210', buildNumber: 'undefined' }
